import './styles/main.scss'
import { createApp } from 'vue'
import { registerPlugins } from '@/plugins'
import App from './App.vue'

const app = createApp(App)

registerPlugins(app)

app.config.warnHandler = function (msg: string) {
  // Vue always logs a warning when we try to inject something what doesnt exists
  // inside vue use lib it always uses the word 'InjectionState' as the injections key
  // we need to turn it off for our deepfront lib
  if (msg === 'injection "Symbol(InjectionState)" not found.') return null
}

app.mount('#app')
